import { render } from "./ClientOverview.vue?vue&type=template&id=53ae5068&scoped=true"
import script from "./ClientOverview.vue?vue&type=script&lang=js"
export * from "./ClientOverview.vue?vue&type=script&lang=js"

import "./ClientOverview.vue?vue&type=style&index=0&id=53ae5068&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ae5068"]])

export default __exports__